/**
 * Справочники (Dictionary Kit)
 * Управляет загрузкой, кэшированием и предотвращением дублирования запросов к справочникам.
 */
window.DK = (() => {
	"use strict";

	const API_URL = '/ajax/api/dictionary';

	// Кэш для сохраненных данных (тип -> данные)
	const dataCache = new Map();

	// Кэш для активных Promise-запросов (тип -> Promise)
	// Нужен, чтобы при одновременном запросе одного справочника из разных мест, запрос к серверу ушел только один раз.
	const pendingRequests = new Map();

	/**
	 * Получение справочника
	 * @param {string} type - тип справочника (regions, categories, arb_orgs и т.д.)
	 * @returns {Promise<Array|Object>}
	 */
	async function fetchDictionary(type) {
		if (dataCache.has(type)) {
			return dataCache.get(type);
		}

		if (pendingRequests.has(type)) {
			return pendingRequests.get(type);
		}

		const requestPromise = fetch(`${API_URL}?type=${encodeURIComponent(type)}`)
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP ошибка: ${response.status}`);
				}
				return response.json();
			})
			.then(result => {
				// Предполагаем, что бэк возвращает { success: true, data: [...] } или сразу массив.
				const data = result.data !== undefined ? result.data : result;

				dataCache.set(type, data);
				pendingRequests.delete(type);
				return data;
			})
			.catch(error => {
				console.error(`[DictKit] Ошибка загрузки справочника "${type}":`, error);
				pendingRequests.delete(type);
				throw error;
			});

		pendingRequests.set(type, requestPromise);
		return requestPromise;
	}

	return {
		get: async (type, callback=null) => {
			try {
				const data = await fetchDictionary(type);

				if (callback && typeof callback === "function") {
					callback(data);
				}

				return data;
			} catch (e) {
				console.error(`Ошибка загрузки ${type}:`, e);
				throw e;
			}
		},

		clearCache: (type) => {
			if (type) {
				dataCache.delete(type);
				pendingRequests.delete(type);
			} else {
				dataCache.clear();
				pendingRequests.clear();
			}
		},
		
		// Проверка, загружен ли уже справочник (синхронно)
		isLoaded: (type) => dataCache.has(type),

		// Получить данные синхронно (вернет null, если еще не загружено)
		getSync: (type) => dataCache.get(type) || null
	};
})();